import type { SVGProps } from 'react'

import {
	AssetsRealestateEmptystate as realEstateIllustration,
	AssetsVehicleEmptystate as vehicleIllustration,
} from '@monthio/icons'
import React from 'react'
import styled from 'styled-components'

import type { OverarchingAssetType } from '../AssetOverview.types'

import { Conditionally } from '../../../modulesTemp/shared/conditionally'

const illustrations: Record<
	OverarchingAssetType,
	(props: SVGProps<SVGSVGElement>) => JSX.Element
> = {
	realEstate: realEstateIllustration,
	vehicle: vehicleIllustration,
}

const Container = styled.div`
	display: flex;
	padding: 16px;

	> svg {
		width: 100%;
		max-width: 400px;
	}

	${(props) => props.theme.breakpoints.down('xs')} {
		justify-content: center;
	}
`

export const AssetEmptyState: React.FC<{
	overarchingAssetType: OverarchingAssetType
	assetCount: number
}> = ({ overarchingAssetType, assetCount }) => {
	const AssetImage = illustrations[overarchingAssetType]
	return (
		<Conditionally
			condition={assetCount === 0 && overarchingAssetType in illustrations}
		>
			<Container>
				<AssetImage />
			</Container>
		</Conditionally>
	)
}
